<tt-page *ngIf="get">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input ttLabel="stockplace_name" [ttModel]="get.stockplace_name" ttReadonly></tt-input>
        <tt-select
            ttLabel="deladronpurch"
            [(ttModel)]="get.deladronpurch"
            (ttModelChange)="readGrid()"
            [ttData]="deliveryAddresses"
            ttDataId="deladronpurch"
            ttDataName="deladronpurch_name"
            ttClearValue=""
        ></tt-select>
        <tt-select
            ttRememberId="w_orderpurch.displaytype_id"
            ttLabel="orderpurch_displaytype"
            [(ttModel)]="get.displaytype_id"
            (ttModelChange)="readGrid()"
            [ttData]="displayTypes"
            ttDataId="displaytype_id"
            ttDataName="displaytype_name"
        ></tt-select>
        <tt-tabs [(ttSelectedId)]="selectedTab" (ttSelectedIdChange)="readGrid()">
            <tt-tab ttId="STATUS" ttLabel="bg_orderpurch_view_status"></tt-tab>
            <tt-tab ttId="PURCHORDERS" ttLabel="bg_orderpurch_view_purchorders"></tt-tab>
        </tt-tabs>
    </tt-card>
    <tt-grid *ngIf="!!statusGrid" [hidden]="selectedTab !== 'STATUS'" class="flex-1" [(ttOptions)]="statusGrid" style="min-height: 500px"></tt-grid>
    <tt-grid *ngIf="!!purchheadsGrid" [hidden]="selectedTab !== 'PURCHORDERS'" class="flex-1" [(ttOptions)]="purchheadsGrid" style="min-height: 500px"></tt-grid>
</tt-page>
